import React from "react";
import { connect } from "react-redux";
import { changeUser, logout } from "../redux/actions";
import { faSignOutAlt, faCompress, faColumns, faClosedCaptioning } from "@fortawesome/free-solid-svg-icons";

import IconButton from "./IconButton";

const PureUserControls = (props) => {

    const doFullscreen = () => {
        document.getElementById("root").requestFullscreen();
    };

    const doViewChange = () => {
        switch(props.view_mode) {
            case "video":
                props.changeUser("view_mode","chat");
                break;
            case "chat":
                props.changeUser("view_mode","full");
                break;
            case "full":
                props.changeUser("view_mode","video");
                break;
            default:
        }
    };

    const doSubtitleChange = () => {
        props.changeUser("subtitles_enabled", !props.subtitles_enabled);
    };

    return (
        <>
            <IconButton title="Leave room" key="exit" icon={faSignOutAlt} onClick={props.logout}>Exit</IconButton>
            <IconButton title="Fullscreen" key="fullscreen" icon={faCompress} onClick={doFullscreen}>Fullscreen</IconButton>
            <IconButton title="Toggle chat/movie/both" key="changeview" icon={faColumns} onClick={doViewChange}>Change View</IconButton>
            {props.subtitle_url ? <IconButton title="Toggle subtitles" highlighted={props.subtitles_enabled} key="togglesubtitles" icon={faClosedCaptioning} onClick={doSubtitleChange}>Toggle Subtitles</IconButton> : ""}
        </>
    );
};

const mapStateToProps = state => ({ 
    password: state.room.password, 
    nick_name: state.user.nick_name, 
    room_key: state.user.room_key, 
    view_mode: state.user.view_mode,
    video_length: state.room.video_length,
    ideal_position: state.user.ideal_position,
    video_position: state.room.video_position,
    room_password: state.user.room_password,
    is_playing: state.room.is_playing,
    video_url: state.room.video_url,
    subtitle_url: state.room.subtitle_url,
    subtitles_enabled: state.user.subtitles_enabled
});

export const UserControls = connect(mapStateToProps, { changeUser, logout })(PureUserControls);
